export default [
  {
    path: '/audio/list',
    name: 'audio-list',
    component: () => import('@/views/audio/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Audio List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Audio' }, { title: 'Audio List', active: true }],
      permissions: ['audio_list']
    }
  }
]
